(function () {
  function getVariantIdInput() {
    const form = document.querySelector('form[action*="/cart/add"]');
    return form ? form.querySelector('input[name="id"]') : null;
  }

  function refreshPickupAvailability(variantId) {
    const url = `${window.location.pathname}?variant=${variantId}`;

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newBlock = doc.querySelector('.productView-pickUp');
        if (!newBlock) return;

        document.querySelectorAll('.productView-pickUp').forEach((oldBlock) => {
          oldBlock.innerHTML = newBlock.innerHTML;
        });
      })
      .catch((e) => console.error('Errore aggiornamento ritiro in negozio:', e));
  }

  const idInput = getVariantIdInput();
  if (!idInput) return;

  let lastVariantId = idInput.value;

  const observer = new MutationObserver(() => {
    if (idInput.value && idInput.value !== lastVariantId) {
      lastVariantId = idInput.value;
      refreshPickupAvailability(lastVariantId);
    }
  });
  observer.observe(idInput, { attributes: true, attributeFilter: ['value'] });

  idInput.addEventListener('change', () => {
    if (idInput.value && idInput.value !== lastVariantId) {
      lastVariantId = idInput.value;
      refreshPickupAvailability(lastVariantId);
    }
  });
})();